import i18n from '@/locales/i18n';

const constant = {
  send_status_options: [
    {
      value: 'SENT',
      text: i18n.t('log.send_status_option.sent'),
    },
    {
      value: 'ERROR',
      text: i18n.t('log.send_status_option.error'),
    },
  ],
  status_options: [
    {
      value: 'SUCCESS',
      text: i18n.t('log.status_option.success'),
    },
    {
      value: 'ERROR',
      text: i18n.t('log.status_option.error'),
    },
  ],
  status_receive_options: [
    {
      value: 'SUCCESS',
      text: i18n.t('log.status_option.success'),
    },
    {
      value: 'FAILED',
      text: i18n.t('log.status_option.error'),
    },
  ],
  matching_error_options: [
    {
      value: '1',
      text: i18n.t('log.matching_error_option.yes'),
    },
    {
      value: '0',
      text: i18n.t('log.matching_error_option.no'),
    },
  ],
};

export default constant;
